import React, { Component } from 'react';
import { connect } from 'react-redux';
import  Actions from '../../Actions';

class Logout extends Component{
    componentDidMount(){
        const { logout } = this.props;
        logout();
    }

    render(){
        return null;
    }
}
const mapStateToProps = () => ({});

export default connect(mapStateToProps, Actions.auth)(Logout);


// WEBPACK FOOTER //
// ./src/Components/App/Logout.js